import React, { Component } from 'react';
import InfluencerFormExternal from '../../components/influencer-form-external';

import PublicHeader from '../../components/public-header';

class CreatorSignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isError: false,
      influencer: null,
      instagramLoading: false,
      thumbnail: null,
      primarySocialHandle: null,
      displayName: null,
      email: null,
      emailerror: null,
      instagramLoaded: false,
      isFormSubmitted: false,
      organisationId: null,
      openModal: false,
    };
  }

  render() {
    return (
      <div style={{ paddingTop: 10 }}>

        <PublicHeader />

        <InfluencerFormExternal />

      </div>
    );
  }
}

export default CreatorSignUp;



/** WEBPACK FOOTER **
 ** ./src/containers/creator-full/index.js
 **/